import type { Template } from "@/types";

export const PO_02_H2_V0: Template[] = [
    {
        id: "po-02-h2v0-01",
        name: "PO 01 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_01.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 0, y: 207, width: 635, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 644, y: 207, width: 635, height: 401, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-02",
        name: "PO 02 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_02.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 46, y: 235, width: 550, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 685, y: 235, width: 550, height: 346, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-03",
        name: "PO 03 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_03.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 77, y: 235, width: 560, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 644, y: 235, width: 560, height: 346, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-04",
        name: "PO 04 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_04.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 41, y: 235, width: 560, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 750, y: 279, width: 417, height: 258, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-05",
        name: "PO 05 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_05.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 111, y: 279, width: 417, height: 258, rotation: 0, imageRotation: 0 },
            { id: "2", x: 678, y: 235, width: 560, height: 346, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-06",
        name: "PO 06 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_06.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 46, y: 423, width: 550, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 685, y: 423, width: 550, height: 346, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-07",
        name: "PO 07 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_07.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 750, y: 279, width: 417, height: 258, rotation: 0, imageRotation: 0 },
            { id: "2", x: 110, y: 279, width: 417, height: 258, rotation: 0, imageRotation: 0 }
        ],
    }
];